import TextInputWithDropdown from './TextInputWithDropdown.jsx';
import { useEffect, useState } from 'react';

const dropdownOptions = [
    { value: 'minutes', label: 'minutes' },
    { value: 'hours', label: 'hours' },
    { value: 'days', label: 'days' },
];

const multipliers = {
    minutes: 1,
    hours: 60,
    days: 60 * 24,
};

const DurationInput = ({
    value,
    onChange,
    id,
    label,
    className,
    autoFocus,
    placeholder,
    excludeOptions,
}) => {
    const [dropdownValue, setDropdownValue] = useState();
    const multiplier = multipliers[dropdownValue] || 1;
    const [loadedAt, setLoadedAt] = useState(new Date());

    useEffect(() => {
        const now = new Date();

        // If we loaded within 100ms of the value being set then assume it's the initial value
        if (now - loadedAt < 500 && value) {
            if (value % multipliers.days === 0) {
                setDropdownValue('days');
            } else if (value % multipliers.hours === 0) {
                setDropdownValue('hours');
            } else {
                setDropdownValue('minutes');
            }
        }
    }, [value]);

    const textValue = value / multiplier;

    return (
        <TextInputWithDropdown
            id={id}
            label={label}
            className={className}
            textValue={textValue || '0'}
            autoFocus={autoFocus}
            placeholder={placeholder}
            setTextValue={newValue => onChange(parseInt(newValue) * multiplier)}
            dropdownValue={dropdownValue}
            setDropdownValue={newValue => {
                setDropdownValue(newValue);
                onChange(parseInt(textValue) * multipliers[newValue]);
            }}
            options={dropdownOptions.filter(
                opt => !excludeOptions || !excludeOptions.includes(opt.value),
            )}
        />
    );
};

export default DurationInput;
